import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { MessageSquare, Mail } from 'lucide-react';
import SmsCampaigns from './SmsCampaigns';
import EmailCampaigns from './EmailCampaigns';
import EventSelector from '../components/common/EventSelector';
import { useEvent } from '../context/EventContext';

const Campaigns = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedEvent, setSelectedEvent } = useEvent();

  // Determine initial tab from URL hash, default to SMS
  const getInitialTab = () => {
    if (location.hash === '#email') return 'email';
    return 'sms';
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  // Update URL hash when tab changes
  useEffect(() => {
    navigate(`#${activeTab}`, { replace: true });
  }, [activeTab, navigate]);

  // Sync state if URL changes externally
  useEffect(() => {
    setActiveTab(getInitialTab());
  }, [location.hash]);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto space-y-6">
        
        {/* Top Level Tabs & Event Selector */}
        <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-200 sticky top-[73px] z-10 mx-6 mt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex gap-2 w-full md:w-auto flex-1">
            <button
              onClick={() => setActiveTab('sms')}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg font-semibold text-sm transition-all duration-200 ${
                activeTab === 'sms'
                  ? 'bg-gradient-to-r from-teal-50 to-emerald-50 text-teal-700 shadow-sm border border-teal-100'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 border border-transparent'
              }`}
            >
              <MessageSquare className="w-4 h-4" />
              SMS Campaigns
            </button>
            <button
              onClick={() => setActiveTab('email')}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg font-semibold text-sm transition-all duration-200 ${
                activeTab === 'email'
                  ? 'bg-gradient-to-r from-teal-50 to-emerald-50 text-teal-700 shadow-sm border border-teal-100'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 border border-transparent'
              }`}
            >
              <Mail className="w-4 h-4" />
              Email Campaigns
            </button>
          </div>

          <div className="w-full md:w-80 flex-shrink-0">
            <EventSelector
              selectedEvent={selectedEvent}
              onEventChange={setSelectedEvent}
              className="w-full"
            />
          </div>
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'sms' && <SmsCampaigns />}
          {activeTab === 'email' && <EmailCampaigns />}
        </div>
        
      </div>
    </Layout>
  );
};

export default Campaigns;
